/* Libraries / React Components / Node_Modules */
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import moment from "moment";

/* Local Imports */
import Pagination from "../Pagination/Pagination";
import { API_URL } from "../../utils/constant";
import Loader from "../resuableComponent/loader";

import BasicBar from "../common/apexChart/basicBar";
import rightImg from "../../assets/images/right-clock.png";
import leftImg from "../../assets/images/left-clock.png";

/* Data */
import {
  fetchFakeSocialMedia,
  fetchSocailRemidiatedFalseTrue,
  fetchFakeSocialMediaGraph,
  fetchFakeSocialMediaTotal,
} from "../../actions/fakeMobileApp";
import {
  fetchSubDomains,
  addRemediationData,
  removeRemediationData,
} from "../../actions/sub-domain";

import RemediationActionButton from "../common/RemediationActionButton";
import { useRemediationActions } from "../../hooks/useRemediationActions";

// Fake Social Media Profile PAGE
const SocialMediaProfile = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const myRef = useRef(null);

  const auth = useSelector((state) => state?.auth?.user);
  const clientType = useSelector((state) => state?.auth?.user?.accessLevel);
  const id = useSelector(
    (state) =>
      state?.summary?.localClient?._id ||
      state?.summary?.clients?.data?.[0]?._id
  );
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.data?.[0]
  );
  const state = useSelector(
    (state) => state?.fakeMobileApp?.fakeSocialMedia?.data
  );
  const total = useSelector((state) => state?.fakeMobileApp?.faketotal?.data);
  const scanCompleted = useSelector(
    (state) => state?.fakeMobileApp?.scanCompleted
  );
  const graphData = useSelector(
    (state) => state?.fakeMobileApp?.socialMediaGraph
  );
  const remediationList = useSelector(
    (state) => state?.auth?.remediationListAll?.data?.data
  );

  // =============== State Management ===============
  // PAGINATION_AND_DISPLAY
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [PageSize, setPerPage] = useState(10);

  // FILTERING_AND_SEARCH
  const [filterData, setfilterData] = useState("");
  const [statusFilterVal, setStatusFilter] = useState([]);
  const [category, setCategory] = useState("all");
  const [type, settype] = useState("all");
  const [status, setStatus] = useState("all");
  const [platform, setPlatform] = useState("all");

  // IDENTIFIERS_AND_METADATA
  const [checkPath, setCheckPath] = useState("");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);

  // MODAL_MANAGEMENT
  const [isModal, setModal] = useState("");

  // ACTION_MANAGEMENT
  const [forValue, setForValue] = useState("forever");
  const [actionNote, setActionNote] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);
  const [addedRemediations, setAddedRemediations] = useState([]);
  const [action, setAction] = useState("");

  // UI_STATE
  const [containerClass, setContainerClass] = useState("data-container");
  const [activeBoxes, setActiveBoxes] = useState({
    box1: false,
    box2: false,
    box3: false,
    box4: false,
    box5: false,
  });
  // ====== COMPUTED VALUES & CONSTANTS ======
  const params = new URLSearchParams(location?.search);
  const modeValue = params.get("mode");
  const modeValueCheck = new URLSearchParams(location?.search).get("mode");

  // Group data by creation date
  let objArray = {};
  for (let count = 0; count < state?.length; count++) {
    let createdAt = state[count].createdAt.split("T")[0];
    if (objArray[createdAt]) {
      objArray[createdAt].push(state[count]);
    } else {
      objArray[createdAt] = [state[count]];
    }
  }

  // Social media related constants
  const facebookMedia = "";
  const linkedinMedia = "";
  const twitterMedia = "";
  const instagramMedia = "";
  // Arrays for storing social media data
  let facebook = [],
    linkedin = [],
    twitter = [],
    instagram = [];
  let dateKey = [];
  // Transform data for social media platforms
  Object.keys(objArray || {}).map((key) => {
    dateKey.push(key);
    let value = objArray[key];
    let facebookMedia = value?.filter((val) => val.source == "facebook");
    let linkedinMedia = value?.filter((val) => val.source == "Linkedin");
    let twitterMedia = value?.filter((val) => val.source == "twitter");
    let instagramMedia = value?.filter((val) => val.source == "instagram");

    facebook.push(facebookMedia?.length || 0);
    linkedin.push(linkedinMedia?.length || 0);
    twitter.push(twitterMedia?.length || 0);
    instagram.push(instagramMedia?.length || 0);
  });

  // Table data processing
  let mapData = state?.data;
  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  const remediationActions = useRemediationActions(
    "delta_social_media_profiles",
    id,
    currentTableData
  );

  // =============== Effect Hooks ===============
  // Update path when location changes
  useEffect(() => {
    setCheckPath(location.search);
  }, [location.search]);

  // Update active boxes when mode changes
  useEffect(() => {
    handleBoxClick("");
  }, [modeValue]);

  // Fetch total data
  useEffect(() => {
    fetchFakeSocialMediaTotal(id, dispatch);
  }, [id, dispatch]);

  // Fetch graph data
  useEffect(() => {
    fetchFakeSocialMediaGraph(id, dispatch);
  }, [id, dispatch]);

  // Fetch data when dependencies change
  useEffect(() => {
    fetchFakeSocialMedia(id, dispatch, page, category, platform, status);
  }, [id, dispatch, page, category, platform, status]);

  // Update remediation list when it changes
  useEffect(() => {
    if (remediationList) {
      const updatedRemediations = remediationList.reduce((results, elem) => {
        return { ...results, [elem._id]: elem };
      }, {});
      setAddedRemediations(updatedRemediations);
    }
  }, [remediationList]);

  // Update total items when data changes
  useEffect(() => {
    setTotalItems(state?.totalProfiles);
  }, [state?.totalProfiles]);

  // Update container class when state is loaded
  useEffect(() => {
    if (state) {
      setTimeout(() => {
        setContainerClass("data-container active");
      }, 300);
    }
  }, [state]);

  // ========= Handlers / Functions =========
  // Scroll handler
  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll
  };

  // Handle box click
  const handleBoxClick = (boxId) => {
    if (modeValue === "report-mode") {
      setActiveBoxes((prevState) => ({
        ...prevState,
        [boxId]: !prevState[boxId],
      }));
    } else {
      setActiveBoxes({});
    }
  };
  // Modal handlers
  const addModal = () => {
    setModal("Form Wizard modal");
  };

  // ====== Checkbox Handlers ======
  // Multiple item selection handler
  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };
  // Single item selection handler
  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };
  // ====== END Checkbox Handlers ======

  // ====== Snooze/Unsooze Function ======
  // Handle Snooze action
  const snooze = (_id, event) => {
    if (event == "markAsRemidiated") {
      let ids = [];
      ids.push(_id);
      const data = {
        action: "markAsRemidiated",
        fakeSocialMediaIds: selectedIds == 0 ? ids : selectedIds,
        actionNote: "",
        for: "forever",
      };
      fetchSocailRemidiatedFalseTrue(id, dispatch, data, page, category, type);
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
    }
  };
  // Handle Unsnooze action
  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      fakeSocialMediaIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchSocailRemidiatedFalseTrue(id, dispatch, data, page, category, type);
    setSelectedIds([]);
  };
  // Handles Form Submission for Snooze/Unsnooze
  const submit = () => {
    const data = {
      action: action,
      fakeSocialMediaIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchSocailRemidiatedFalseTrue(id, dispatch, data, page, category, type);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };
  // ====== END Snooze/Unsooze Function ======

  // ====== Export/Download Functions ======
  // Handle file download from API
  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/getFakeSocialMediav2/${id}/excel`,
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Social Media Page.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    }
  };
  // ====== END Export/Download Functions ======

  // ======= Remediation List Bucket =======
  // Remove item from remediation bucket
  const removeToCart = (_id) => (e) => {
    $.confirm({
      title: "Are you sure?",
      content:
        "Do you really want to remove this from the Remediation List Panel?",
      type: "red",
      buttons: {
        ok: {
          text: "Remove",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            e.preventDefault();
            removeRemediationData(_id, dispatch, id).then(() => {
              fetchFakeSocialMedia(id, dispatch, page, category);
            });
          },
        },
        cancel: function () {},
      },
    });
  };
  // Adds item to remediation bucket
  const addToCart = (row) => (e) => {
    let data = {
      collectionName: "delta_social_media_profiles",
      organisationId: id,
      recordId: row?._id,
    };
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to add this to the Remediation List Panel ?",
      type: "green",
      buttons: {
        ok: {
          text: "Add",
          btnClass: "btn-green",
          keys: ["enter"],
          action: function () {
            e.preventDefault();
            addRemediationData(data, dispatch).then(() => {
              fetchFakeSocialMedia(id, dispatch, page, category);
            });
          },
        },
        cancel: function () {},
      },
    });
  };
  // ===== END Remediation List Bucket =====

  return (
    <div>
      {/* <Header type="brand" />
      <SideNav type="brand" /> */}

      {state ? (
        <div className={containerClass}>
          <div className="tab_facebook">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-9 mb-5">
                <div className="row_boxes">
                  <div
                    className={`box box-active`}
                    onClick={() => handleBoxClick("box1")}
                  >
                    <span className="profile">PROFILES</span>
                    <div className="box_up">
                      {/* <div className="box_6">
                        <h4>{facebookMedia.length}</h4>
                        <p>Previous</p>
                      </div> */}
                      <img
                        src="/assets/images/fb.png"
                        className="img-fluid"
                        alt=""
                      />
                      <div className="box_7">
                        <h4>{total?.totalFacebookProfiles}</h4>
                        <p>Total Count</p>
                      </div>
                    </div>
                    <a href="">
                      <span>
                        <img
                          src="/assets/images/plus.png"
                          className="img-fluid"
                          alt=""
                        />
                      </span>
                      <p>add Scan process</p>
                    </a>
                  </div>
                  <div
                    className={`box ${activeBoxes.box2 ? "box-active" : ""}`}
                    onClick={() => handleBoxClick("box2")}
                  >
                    <span className="profile">PROFILES</span>
                    <div className="box_up">
                      {/* <div className="box_6">
                        <h4>{instagramMedia.length}</h4>
                        <p>Previous</p>
                      </div> */}
                      <img
                        src="/assets/images/instagram_icon.png"
                        className="img-fluid"
                        alt=""
                      />
                      <div className="box_7">
                        <h4>{total?.totalInstagramProfiles}</h4>
                        <p>Total Count</p>
                      </div>
                    </div>
                    <a href="">
                      <span>
                        <img
                          src="/assets/images/plus.png"
                          className="img-fluid"
                          alt=""
                        />
                      </span>
                      <p>add Scan process</p>
                    </a>
                  </div>
                  <div
                    className={`box ${activeBoxes.box3 ? "box-active" : ""}`}
                    onClick={() => handleBoxClick("box3")}
                  >
                    <span className="profile">PROFILES</span>
                    <div className="box_up">
                      {/* <div className="box_6">
                        <h4>{linkedinMedia.length}</h4>
                        <p>Previous</p>
                      </div> */}
                      <img
                        src="/assets/images/linkedin_icon.png"
                        className="img-fluid"
                        alt=""
                      />
                      <div className="box_7">
                        <h4>{total?.totalLiknedInProfiles}</h4>
                        <p>Total Count</p>
                      </div>
                    </div>
                    <a href="">
                      <span>
                        <img
                          src="/assets/images/plus.png"
                          className="img-fluid"
                          alt=""
                        />
                      </span>
                      <p>add Scan process</p>
                    </a>
                  </div>
                  <div
                    className={`box ${activeBoxes.box4 ? "box-active" : ""}`}
                    onClick={() => handleBoxClick("box4")}
                  >
                    <span className="profile">PROFILES</span>
                    <div className="box_up">
                      {/* <div className="box_6">
                        <h4>{twitterMedia.length}</h4>
                        <p>Previous</p>
                      </div> */}
                      <img
                        src="/assets/images/twitter_icon.png"
                        className="img-fluid"
                        alt=""
                      />
                      <div className="box_7">
                        <h4>{total?.totalTwitterProfiles}</h4>
                        <p>Total Count</p>
                      </div>
                    </div>
                    <a href="">
                      <span>
                        <img
                          src="/assets/images/plus.png"
                          className="img-fluid"
                          alt=""
                        />
                      </span>
                      <p>add Scan process</p>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-2"></div>
              <div className="col-md-9 mt-5 mb-5">
                <div className="row_boxes row_boxes_graph">
                  <div
                    className={`box p-1 box-active`}
                    onClick={() => handleBoxClick("box1")}
                  >
                    <span className="profile">PROFILES</span>
                    <div className="box_up">
                      <img
                        src="/assets/images/fb.png"
                        className="img-fluid imgGraphIcon"
                        alt=""
                      />
                      <div className="d-flex justify-content-center align-items-end">
                        <img
                          src={rightImg}
                          className="img-fluid position-relative"
                        />
                        <BasicBar
                          date={graphData?.dates}
                          data={graphData?.scanDetails?.facebook}
                        />
                        <img
                          src={leftImg}
                          className="img-fluid position-relative"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`box p-1 ${
                      activeBoxes.box2 ? "box-active" : ""
                    }`}
                    onClick={() => handleBoxClick("box2")}
                  >
                    <span className="profile">PROFILES</span>
                    <div className="box_up">
                      <img
                        src="/assets/images/instagram_icon.png"
                        className="img-fluid imgGraphIcon"
                        alt=""
                      />
                      <div className="d-flex justify-content-center align-items-end">
                        <img
                          src={rightImg}
                          className="img-fluid position-relative"
                        />
                        {/* <BasicBar /> */}
                        <BasicBar
                          date={graphData?.dates}
                          data={graphData?.scanDetails?.instagram}
                        />

                        <img
                          src={leftImg}
                          className="img-fluid position-relative"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`box p-1 ${
                      activeBoxes.box3 ? "box-active" : ""
                    }`}
                    onClick={() => handleBoxClick("box3")}
                  >
                    <span className="profile">PROFILES</span>
                    <div className="box_up">
                      <img
                        src="/assets/images/linkedin_icon.png"
                        className="img-fluid imgGraphIcon"
                        alt=""
                      />
                      <div className="d-flex justify-content-center align-items-end">
                        <img
                          src={rightImg}
                          className="img-fluid position-relative"
                        />
                        {/* <BasicBar /> */}
                        <BasicBar
                          date={graphData?.dates}
                          data={graphData?.scanDetails?.linkdin}
                        />

                        <img
                          src={leftImg}
                          className="img-fluid position-relative"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`box p-1 ${
                      activeBoxes.box4 ? "box-active" : ""
                    }`}
                    onClick={() => handleBoxClick("box4")}
                  >
                    <span className="profile">PROFILES</span>
                    <div className="box_up">
                      <img
                        src="/assets/images/twitter_icon.png"
                        className="img-fluid imgGraphIcon"
                        alt=""
                      />
                      <div className="d-flex justify-content-center align-items-end">
                        <img
                          src={rightImg}
                          className="img-fluid position-relative"
                        />
                        {/* <BasicBar /> */}
                        <BasicBar
                          date={graphData?.dates}
                          data={graphData?.scanDetails?.twitter}
                        />

                        <img
                          src={leftImg}
                          className="img-fluid position-relative"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row clearfix no_margin" style={{ marginTop: "20px" }}>
            <div className="col-sm-2"></div>
            <div className="col-sm-9">
              <div className="row_boxes">
                {/* <div className="gradinet-effect w-100"> 
               {scanDetails && <SubscriberChart dates={scanDetails?.dates} ipArray={ipArray} color={["#6574cd"]} yAxis="Similar Domains found" />} 
               {scanDetails && <BasicLineColumn dates={scanDetails?.dates} ipArray={ipArray} color={["#6574cd"]} yAxis="Similar Domains found" />} 
               {scanDetails && <SubscriberChart dates={dateKey} facebook={facebook} linkedin={linkedin} twitter={twitter} instagram={instagram} />} 
               </div> */}
              </div>
            </div>
          </div>

          <div className="row clearfix no_margin" style={{ marginTop: "20px" }}>
            <div className="col-sm-2"></div>
            <div className="col-sm-9" style={{ padding: "0" }}>
              <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
                <li className="nav-item">
                  <a
                    className={`nav-table-tab nav-link ${
                      category === "all" ? "active" : ""
                    }`}
                    onClick={() => {
                      setCategory("all");
                      settype("all");
                      setPage(1);
                      setStatus("all");
                      setPlatform("all");
                      setSelectedIds([]);
                    }}
                  >
                    Current
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link nav-table-tab ${
                      category === "risk-accepted" ? "active" : ""
                    }`}
                    onClick={() => {
                      setCategory("risk-accepted");
                      settype("all");
                      setPage(1);
                      setStatus("all");
                      setPlatform("all");
                      setSelectedIds([]);
                    }}
                  >
                    Risk Accepted
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link nav-table-tab ${
                      category === "false-positive" ? "active" : ""
                    }`}
                    onClick={() => {
                      setCategory("false-positive");
                      settype("all");
                      setPage(1);
                      setStatus("all");
                      setPlatform("all");
                      setSelectedIds([]);
                    }}
                  >
                    False Positive
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link nav-table-tab ${
                      category === "remidiated" ? "active" : ""
                    }`}
                    onClick={() => {
                      setCategory("remidiated");
                      settype("all");
                      setPage(1);
                      setStatus("all");
                      setPlatform("all");
                      setSelectedIds([]);
                    }}
                  >
                    Remediated
                  </a>
                </li>
              </ul>
              <div className="row mb-2">
                <div className="col-lg-4 col-md-12">
                  <select
                    className="custom-select custom-select-sm form-control form-control-sm"
                    value={platform}
                    onChange={(e) => {
                      setPlatform(e.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="all">All</option>
                    <option value="facebook">Facebook</option>
                    <option value="linkedin">LinkedIn</option>
                    <option value="twitter">X.com</option>
                    <option value="instagram">Instagram</option>
                  </select>
                </div>
                <div className="col-lg-4 col-md-12">
                  <select
                    className="custom-select custom-select-sm form-control form-control-sm"
                    value={status}
                    onChange={(e) => {
                      setStatus(e.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="all">All</option>
                    <option value="verified">Verified</option>
                    <option value="unverified">Unverified</option>
                    <option value="linkdown">Takedown</option>
                  </select>
                </div>
                {/* Download Excel File */}
                <div className="col-md-4 col-sm-12 text-right hidden-xs">
                  {client?.subscriptionType != "trial" &&
                    currentTableData?.length !== 0 && (
                      <span>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            downloadFile();
                          }}
                          style={{
                            float: "right",
                            color: "black",
                            fontWeight: "bold",
                          }}
                          href="/add-report"
                          className="btn btn-primary mr-1"
                        >
                          <i
                            className="fa fa-file-excel-o"
                            style={{ color: "black" }}
                          ></i>
                        </a>
                      </span>
                    )}
                </div>
              </div>
              <div className="row_boxes row_boxes_table">
                <div
                  className={`table_box ${
                    activeBoxes.box5 ? "table-box-active" : ""
                  }`}
                  onClick={() => handleBoxClick("box5")}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        {auth?.accessLevel != "Threat Analyst" &&
                          (category === "all" ||
                            category === "risk-accepted" ||
                            category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )}
                        <th>#</th>
                        <th>Status</th>
                        <th>Platform</th>
                        <th>Page URL</th>
                        <th>Last Updated at</th>
                        {auth?.accessLevel != "Threat Analyst" &&
                          (category === "all" ||
                            category === "risk-accepted" ||
                            category === "false-positive") && (
                            <th style={{ width: "80" }}>Action</th>
                          )}
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTableData?.map((res, index) => {
                        let source =
                          res?.source || res?.socialMediaPlatform || "NA";
                        const pageCount = (page - 1) * 10 + 1;
                        return (
                          <tr key={index}>
                            {auth?.accessLevel != "Threat Analyst" &&
                              (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                <td>
                                  <input
                                    onClick={() => singleClick(res?._id)}
                                    checked={selectedIds?.includes(res?._id)}
                                    type="checkbox"
                                    className="checkUncheck"
                                  />
                                </td>
                              )}
                            <td style={{ whiteSpace: "unset" }}>
                              <span>{pageCount + index}</span>
                            </td>
                            <td>
                              {" "}
                              <span
                                className={
                                  res?.isSuspicious
                                    ? "badge badge-success"
                                    : "badge badge-danger"
                                }
                              >
                                {res?.isSuspicious ? "Verified" : "Unverified"}
                              </span>
                              {res?.isLinkDown && (
                                <span className="badge badge-warning">
                                  Take down
                                </span>
                              )}
                            </td>
                            <td>
                              {source.charAt(0).toUpperCase() + source.slice(1)}
                            </td>
                            <td style={{ whiteSpace: "unset" }}>
                              <a
                                href={`${res?.link || res?.fakePageUrl}`}
                                target="_blank"
                                style={{ color: "white" }}
                                rel="noreferrer"
                              >
                                {res?.link || res?.fakePageUrl}
                              </a>
                            </td>
                            <td>
                              {res?.updatedAt
                                ? moment(res?.updatedAt).format(
                                    "DD-MM-YYYY HH:MM"
                                  )
                                : res?.createdAt
                                ? moment(res?.createdAt).format(
                                    "DD-MM-YYYY HH:MM"
                                  )
                                : "NA"}
                            </td>
                            {/* {auth?.accessLevel != "Threat Analyst" &&
                              category === "all" && (
                                <td>
                                  <Box sx={{ width: 200 }}>
                                    <FormControl fullWidth>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={selectedValue}
                                        onChange={(event) => {
                                          setAction(event.target.value);
                                          snooze(res?._id, event.target.value);
                                        }}
                                      >
                                        <MenuItem value="pleaseSelect">
                                          Snooze Options
                                        </MenuItem>
                                        <MenuItem
                                          value="riskAccepted"
                                          onClick={() => {
                                            addModal();
                                            setLookalikeAppId([res._id]);
                                          }}
                                        >
                                          Risk Accepted
                                        </MenuItem>
                                        <MenuItem
                                          value="markAsFalsePositive"
                                          onClick={() => {
                                            addModal();
                                            setLookalikeAppId([res._id]);
                                          }}
                                        >
                                          False Positive
                                        </MenuItem>
                                        <MenuItem value="markAsRemidiated">
                                          Remediated
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Box>
                                </td>
                              )}
                            {auth?.accessLevel != "Threat Analyst" &&
                              (category === "risk-accepted" ||
                                category === "false-positive" ||
                                category === "remidiated") && (
                                <td>
                                  <button
                                    className="btn btn-primary btn-sm mr-1 Unsnooze"
                                    onClick={() => Unsnoozed(res?._id)}
                                  >
                                    Unsnooze
                                  </button>
                                </td>
                              )} */}
                            {clientType == "Admin" ? (
                              <td>
                                <RemediationActionButton
                                  row={res}
                                  shouldShowPlus={remediationActions.shouldShowPlusButton(
                                    res
                                  )}
                                  onAdd={() =>
                                    remediationActions.addToCart(res)
                                  }
                                  onRemove={remediationActions.removeFromCart}
                                  clientType={clientType}
                                  remediationType="Social Media Profiles"
                                />
                                {/* {res?.isTicketChecked == false ? (
                                  <button
                                    onClick={addToCart({
                                      ...res,
                                      remediationType: "Social Media Profile",
                                    })}
                                  >
                                    <span className="fa fa-plus action_icon"></span>
                                  </button>
                                ) : (
                                  <button onClick={removeToCart(res?._id)}>
                                    <span className="fa fa-minus action_icon"></span>
                                  </button>
                                )} */}
                              </td>
                            ) : null}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="dataTables_paginate">
                {totalItems > 0 && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={page}
                    totalCount={totalItems}
                    pageSize={PageSize}
                    onPageChange={(page) => setPage(page)}
                  />
                )}
              </div>
            </div>
          </div>
          <div
            className={`modal fade Form-Wizard-modal ${
              isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
          >
            <div className="modal-dialog modal-lg" id="clientModal">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {action == "markAsFalsePositive"
                      ? "Mark As False Positive"
                      : "Risk Accepted"}
                  </h5>
                  <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setModal("");
                      setActionNote("");
                    }}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body pricing_page modal_mob">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                      <div className="row clearfix">
                        <div className="col-md-12">
                          <label className="col-lg-6 col-md-12">
                            Snooze for
                          </label>
                          <div className="form-group ol-lg-12 col-md-12">
                            <select
                              className="custom-select custom-select-sm form-control form-control-sm"
                              onChange={(e) => setForValue(e.target.value)}
                            >
                              <option value="forever">Forever</option>
                              <option value="3 months">3 Months</option>
                              <option value="6 months">6 Months</option>
                              <option value="12 months">12 Months</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <label className="col-lg-12 col-md-12">Detail</label>
                          <div className="form-group col-lg-12 col-md-12">
                            <textarea
                              onChange={(e) => setActionNote(e.target.value)}
                              className="form-control"
                              value={actionNote}
                              rows="3"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className="col-lg-12 col-md-12"
                          style={{ marginRight: "28px" }}
                        >
                          <button
                            type="button"
                            style={{ color: "black", fontWeight: "bold" }}
                            onClick={submit}
                            className="btn btn-round btn-primary mr-1 pull-right"
                          >
                            Submit
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="button"
                            onClick={() => {
                              setModal("");
                              setActionNote("");
                            }}
                            className="btn btn-round btn-default pull-right"
                            style={{ marginRight: "10px" }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default SocialMediaProfile;
